import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { API_ORIGIN } from '../lib/api.js';

/** rydres.com/w/<token> on a QR code or in a text opens the PDF straight from the API. */
export function WaybillRedirect() {
  const { token = '' } = useParams();
  useEffect(() => {
    location.replace(`${API_ORIGIN}/v1/public/waybills/${encodeURIComponent(token)}`);
  }, [token]);
  return <div className="p-6 text-muted">Opening the waybill…</div>;
}
